import { render, staticRenderFns } from "./userCent.vue?vue&type=template&id=a9220552&scoped=true"
import script from "./userCent.vue?vue&type=script&lang=js"
export * from "./userCent.vue?vue&type=script&lang=js"
import style0 from "./userCent.vue?vue&type=style&index=0&id=a9220552&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9220552",
  null
  
)

export default component.exports